import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorRutaComponent } from './components/error-ruta/error-ruta.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { RouterGuard } from './modules/general/router.guard';

const routes: Routes = [
	{
		path: '', pathMatch: 'full',redirectTo: '/error' 
	},
	{
		path:  'error', component: ErrorRutaComponent
	},
	{
		path: 'inicio', children : [
			{ path: '', component: ErrorRutaComponent},
			{ path: ':infoAgenda', component: InicioComponent}
			
		]
	},
	{
		path: '**', redirectTo: '/error', pathMatch: 'full'
	}

];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
    useHash: true,
    relativeLinkResolution: 'legacy'
})],
	exports: [RouterModule],
	providers: [
		RouterGuard
	]
})
export class AppRoutingModule { }
